import { UserRole } from '@baseball-near-you/common';
import { PersonalUserPositionForm } from '@bb/components/PersonalUserForms/PersonalUserPositionForm';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';

export function PositionStep(props: {
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile } = useUserProfile();

  return (
    <div>
      <div className="flex flex-col">
        <p className="font-medium text-lg">
          {userProfile?.role === UserRole.Parent
            ? 'Which positions does your athlete play?'
            : 'Which positions do you play?'}
        </p>
        <p className="text-gray-500 text-sm">Choose all that apply.</p>
      </div>
      <PersonalUserPositionForm
        onSuccess={props.onStepSuccess}
        submitButtonLabel="Continue"
      />
    </div>
  );
}
